module.exports = __webpack_public_path__ + "media/images/payments/bitpay-dark-d698662001b0492a7bc81a706c8cb2aa.svg";